import { render, staticRenderFns } from "./VendorsForm.vue?vue&type=template&id=467e83f7&scoped=true"
import script from "./VendorsForm.vue?vue&type=script&lang=js"
export * from "./VendorsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467e83f7",
  null
  
)

export default component.exports